

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface SupplierParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface Supplier {
   
    id?: string;
    name: string;
    tenantId?: string;
    branchId?: string;
    creditDays:number;
    gstn:string;
    drugLicNo:string;
    address:string;
     area:string;
    city:string;
    stateId:string;
    countryId:string;
    pincode:string;
    workPhone:string;
    contactName:string;
    mobile:string;
    altrMobile:string;
    email:string;
    bankName:string;
    ifscCode:string;
    accountNum:string;
    branchName:string;
    //New
    districtId?:string;
    supplierType?:string;

    medicineSuppliersDetails: any[];
    assetSuppliersDetails:any[];
    itemSuppliersDetails:any[];
    createdBy?:number | null;
    createdDate?: Date | string | null;
    updatedBy?:number | null;
    updatedDate?: Date | string | null;
    archiveFlag?: boolean;
    
  parameters?: SupplierParameter[];
  links?: any;
  panNo?:string;
}

export abstract class SupplierData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract getById(url: string): Observable<any>;
  
  abstract list(url: string): Observable<Supplier[]>;
  abstract listAny(url: string): Observable<any[]>;
  abstract create(url: string,data: Supplier): Observable<any>;
  abstract update(url: string,data: Supplier): Observable<any>;
  abstract delete(url: string): Observable<any>;
  //UploadData
  abstract postData(url: string,data: any): Observable<any>;

}

